import { PropTypes } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import classes from '../../index.module.scss'
import { POPUP_FIELDS_KEYS, SELECT_FIELD } from '../constants'
import { selectListFieldRequest, setListFieldRequest } from '../store/slice'

export const DeleteAddButtons = ({
  showAddBtn,
  showDeleteBtn,
  index,
  dataKeyListRequest,
  setIsValid,
  isValid,
  keyItem,
}) => {
  const dispatch = useDispatch()
  const listFieldRequest = useSelector(selectListFieldRequest)

  const handleDeleteItem = (index) => {
    dispatch(
      setListFieldRequest(
        listFieldRequest.filter((item, ind) => ind !== index),
      ),
    )
  }

  const handleAddItem = () => {
    if (!!dataKeyListRequest[POPUP_FIELDS_KEYS.NONE]) return
    dispatch(
      setListFieldRequest([
        ...listFieldRequest,
        {
          label: SELECT_FIELD.label,
          value: 'none',
          inputValue: '',
          isI18n: true,
          fieldCode: 'none',
        },
      ]),
    )
    setIsValid((prev) => ({
      ...prev,
      [POPUP_FIELDS_KEYS.NONE]: true,
    }))
  }

  return (
    <Element
      className={classes.buttons}
      style={{
        marginTop:
          keyItem === POPUP_FIELDS_KEYS.NONE && !isValid[POPUP_FIELDS_KEYS.NONE]
            ? -12
            : 0,
      }}
    >
      <Element
        className={classes.verticalLine}
        style={{ backgroundColor: '#D5D5D5' }}
      />
      <Element
        className={`${classes.iconPlus} ${!showAddBtn ? classes.hidden : ''}`}
        onClick={() => handleAddItem()}
      >
        <Icon
          className="icon-plus-circle-fill"
          style={{
            fontSize: 16,
            color: !!dataKeyListRequest[POPUP_FIELDS_KEYS.NONE]
              ? '#9C9C9C'
              : '#2C73E8',
          }}
        />
      </Element>
      <Element
        className={`${classes.iconDelete} ${
          !showDeleteBtn ? classes.hidden : ''
        }`}
        onClick={() => handleDeleteItem(index)}
      >
        <Icon
          className="icon-trash-fill"
          style={{ fontSize: 16, color: '#9C9C9C' }}
        />
      </Element>
    </Element>
  )
}

DeleteAddButtons.propTypes = {
  showAddBtn: PropTypes.bool,
  showDeleteBtn: PropTypes.bool,
}

DeleteAddButtons.defaultProps = {
  showAddBtn: true,
  showDeleteBtn: true,
}
